import PageHeader from "../components/PageHeader";
import HireLaravelDeveloperContent from "../components/Hire-Laravel-Developer-Content";

const HireLaravelDevelopers = () => {
    return (
        <>
            <PageHeader pagetitle="Laravel Developer" breadcrumbMenu="Home" breadcrumbMenuActive="Laravel Developer" image="/images/laravel-developer.png" />
            <HireLaravelDeveloperContent />
        </>
    )
}

export default HireLaravelDevelopers;